var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8 23.1998C2.03 23.1998 1.3706 22.9254 0.821802 22.3766C0.273002 21.8278 -0.000930956 21.1689 2.37691e-06 20.3998V3.59981C2.37691e-06 2.82981 0.274402 2.17041 0.823202 1.62161C1.372 1.07281 2.03094 0.798874 2.8 0.799807H25.2C25.97 0.799807 26.6294 1.07421 27.1782 1.62301C27.727 2.17181 28.0009 2.83074 28 3.59981V20.3998C28 21.1698 27.7256 21.8292 27.1768 22.378C26.628 22.9268 25.9691 23.2007 25.2 23.1998H2.8ZM14 13.3998L25.2 6.39981V3.59981L14 10.5998L2.8 3.59981V6.39981L14 13.3998Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.28f37543e9a6bb549a1e5dd5548b9f8d.svg";
export { ForwardRef as ReactComponent };